import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

export interface SubContractPayload {
  jobId: string;
  businessId: string;
  rateFrom: number;
  rateTo: number;
  rateType: string;
  b2bNetworkIds: string[];
  personalNetworkIds: string[];
  memberNetworkIds: string[];
}

export interface SubmittedForPayload {
  customerBusinessId: string;   // upstream receiver
  supplierBusinessId: string;   // current holder = my business
  submittedByUserId: string;    // userId (not businessId)
  submittedRate: string;
  submittedRateType: string;
}

@Injectable({ providedIn: 'root' })
export class SubContractService {

  constructor(private api: ApiService) {}

  /** GET /sub-contract/details — get existing sub-contract details for edit modal */
  getSubContractDetails(jobId: string, businessId: string): Observable<any> {
    return this.api.query(`sub-contract/details?jobId=${jobId}&businessId=${businessId}`);
  }

  publishSubContract(payload: SubContractPayload & { subContractedBy: string }): Observable<any> {
    return this.api.create('sub-contract/publish', payload);
  }

  updateSubContract(payload: SubContractPayload): Observable<any> {
    return this.api.updatePut('sub-contract/update', payload);
  }

  removeSubContract(jobId: string, businessId: string): Observable<any> {
    return this.api.delete(`sub-contract/remove/${jobId}/${businessId}`);
  }

  /** POST /sub-contract/eligible-jobs — find jobs eligible for sub-contracting by a supplier */
  getEligibleJobs(businessId: string, businessNetworks: string[], limit = 20, searchAfterKey?: any): Observable<any> {
    return this.api.create('sub-contract/eligible-jobs', {
      businessId,
      businessNetworks,
      limit,
      searchAfterKey: searchAfterKey || null
    });
  }

  /** POST /sub-contract/bulk-publish — publish multiple jobs for sub-contracting in one call */
  bulkPublishSubContract(payloads: SubContractPayload[]): Observable<any> {
    return this.api.create('sub-contract/bulk-publish', payloads);
  }

  /**
   * POST /sub-contract/submit-for/{jobId}/{applicantUserId} — append a new chain entry
   * for an applicant after L2-INTERVIEW. Returns the updated submittedForChain on success.
   */
  submitForUpstream(jobId: string, applicantUserId: string, payload: SubmittedForPayload): Observable<any> {
    return this.api.create(`sub-contract/submit-for/${jobId}/${applicantUserId}`, payload);
  }
}
